// LoginError.jsx

import React from 'react';

// Utilities

// CSS
import './LoginError.css';

/**
 * LoginError Component
 * 
 * This component renders a login form error message.
 * 
 * @param {string} text - The text of the label.
 * 
 * @returns {ReactNode} The rendered component.
 */
const LoginError = ({ text }) => {

  return (

    <div
      className="login-error-container"
      style={{
        backgroundColor: "#FFFFFF22",
        color: '#FFFFFF',
        borderColor: "#FFFFFF22"
      }}>
      {text}
    </div>

  );
};

export default LoginError;
